import { render, staticRenderFns } from "./OdontogramTooth.vue?vue&type=template&id=299789c9"
import script from "./OdontogramTooth.vue?vue&type=script&lang=js"
export * from "./OdontogramTooth.vue?vue&type=script&lang=js"
import style0 from "./OdontogramTooth.vue?vue&type=style&index=0&id=299789c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports